export default __webpack_public_path__ + "static/media/logo-simple-white.a3209eef.svg";